module.exports = __webpack_public_path__ + "static/img/2020.a614276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2020.jpg
// module id = 310
// module chunks = 0